<template>
  <div>
    <b-breadcrumb>
      <b-breadcrumb-item to="/home" @click="updateListCategory('listCategoryHome')">Home</b-breadcrumb-item>
      <b-breadcrumb-item href="#overdue" active>Overdue</b-breadcrumb-item>
    </b-breadcrumb>
    <h1 class="template-name">Overdue</h1>
    <p>It is never too late to finish the tasks.</p>
    <b-tabs content-class="mt-3" active-nav-item-class="font-weight-bold">
      <b-tab title="Personal List" active>
        <div class="task-container">
          <div v-if="showPlaceholderImagePersonal && !hideWhenInitialLoadPersonal" class="no-task-container">
            <b-img class="no-task-picture" :src="require('../../assets/no_task.png')"
                   alt="No task picture"></b-img>
            <h2>No overdue task</h2>
            <p>Keep it up, do not let any task slip by!</p>
          </div>
          <regular-with-origin-task-cell v-for="overdueTask in personalOverdueTaskDocuments" :key="overdueTask.taskId"
                                         :task-details="overdueTask"></regular-with-origin-task-cell>
        </div>
      </b-tab>
      <b-tab title="Collaborative List">
        <div class="task-container">
          <div v-if="showPlaceholderImageCollaborative && !hideWhenInitialLoadCollaborative" class="no-task-container">
            <b-img class="no-task-picture" :src="require('../../assets/no_task.png')"
                   alt="No task picture"></b-img>
            <h2>No overdue task</h2>
            <p>Keep it up, do not let any task slip by!</p>
          </div>
          <regular-with-origin-task-cell v-for="overdueTask in collaborativeOverdueTaskDocuments"
                                         :key="overdueTask.taskId"
                                         :task-details="overdueTask"></regular-with-origin-task-cell>
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import RegularWithOriginTaskCell from "../table_cells/task_cells/RegularWithOriginTaskCell"
import {mapActions, mapGetters} from "vuex";
import firebase from "firebase";
import {db} from "../../main";

export default {
  data() {
    return {
      showPlaceholderImagePersonal: null,
      showPlaceholderImageCollaborative: null,
      hideWhenInitialLoadPersonal: true,
      hideWhenInitialLoadCollaborative: true,
      personalOverdueTaskDocuments: null,
      collaborativeOverdueTaskDocuments: null
    }
  },
  components: {
    regularWithOriginTaskCell: RegularWithOriginTaskCell
  },
  methods: {
    ...mapActions([
      "updateListCategory"
    ]),
    getOverdueTaskData() {
      const date = new Date()
      date.setHours(0, 0, 0, 0)

      const currentDate = firebase.firestore.Timestamp.fromDate(date)

      this.$bind(
          'personalOverdueTaskDocuments',
          db
              .collectionGroup('tasks')
              .where('assigneeId', '==', this.$store.getters.user.data.id)
              .where('taskType', '==', 'Personal Task')
              .where('dueDate', '<', currentDate)
              .where('completed', '==', false)
              .orderBy('dueDate', 'asc')
      ).then(() => {
        if (this.personalOverdueTaskDocuments.length === 0) {
          this.showPlaceholderImagePersonal = true
        }
        this.hideWhenInitialLoadPersonal = false
      })

      this.$bind(
          'collaborativeOverdueTaskDocuments',
          db
              .collectionGroup('tasks')
              .where('assigneeId', '==', this.$store.getters.user.data.id)
              .where('taskType', '==', 'Collaborative Task')
              .where('dueDate', '<', currentDate)
              .where('completed', '==', false)
              .orderBy('dueDate', 'asc')
      ).then(() => {
        if (this.collaborativeOverdueTaskDocuments.length === 0) {
          this.showPlaceholderImageCollaborative = true
        }
        this.hideWhenInitialLoadCollaborative = false
      })
    }
  },
  watch: {
    personalOverdueTaskDocuments(newProperties, oldProperties) {
      this.showPlaceholderImagePersonal = this.personalOverdueTaskDocuments.length === 0
    },
    collaborativeOverdueTaskDocuments(newProperties, oldProperties) {
      this.showPlaceholderImageCollaborative = this.collaborativeOverdueTaskDocuments.length === 0
    }
  },
  mounted() {
    this.getOverdueTaskData()
  }
}
</script>

<style scoped>
.no-task-container {
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.no-task-picture {
  width: 375px;
  margin-bottom: 1em;
}

.template-name {
  font-size: 2em;
  margin-bottom: 0.5em;
}

.task-container {
  height: 65vh;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
}
</style>
